import {useQueries, useQuery} from "@tanstack/react-query";
import {BusinessesApi, Merchant, MerchantSearchResult} from "@devour/client";
import getConfig from "../utils/getConfig";

async function fetchMerchant(merchantId: string, placeId?: string): Promise<Merchant> {
    if (!merchantId) {
        return;
    }

    return await new BusinessesApi(getConfig()).getMerchantsFullId({
        id: merchantId,
        placeId: placeId,
    });
}

function merchantQuery(merchantId: string, placeId?: string) {
    return {
        queryKey: [
            "merchant",
            merchantId,
            placeId,
        ],
        queryFn: () => fetchMerchant(merchantId, placeId),
        keepPreviousData: true,
        staleTime: 0, // Always consider data stale for fresh updates
        refetchInterval: 60000, // Check for updates every 60 seconds when page is visible
        refetchIntervalInBackground: false, // Don't poll when tab is hidden (resource efficient)
        refetchOnWindowFocus: false,
        enabled: !!merchantId,
    } as const;
}

export function useMerchant(merchantId: string, placeId?: string) {
    // const queryClient = useQueryClient();

    return useQuery(merchantQuery(merchantId, placeId));
}

export function useMerchants(merchants: MerchantSearchResult[], placeId?: string) {
    const queries = merchants?.map(r => merchantQuery(r._id, placeId));

    return useQueries({
        queries: queries ?? [],
    });
}
